import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { API_CONSTANTS, COOKIES, TIME } from '@app/app.constants';
import { ConfigService } from '@app/core/config.service';
import * as i0 from "@angular/core";
import * as i1 from "../../config.service";
import * as i2 from "ngx-cookie-service/cookie-service/cookie.service";
import * as i3 from "@angular/common/http";
var AuthTokenService = /** @class */ (function () {
    function AuthTokenService(config, cookieService, http) {
        this.config = config;
        this.cookieService = cookieService;
        this.http = http;
        this.webApiUrl = this.config.getValue('webApiUrl');
    }
    /**
     * Gets an auth cookie
     * @param version   api version (optional - defaults to v1)
     */
    AuthTokenService.prototype.getAuthToken = function (baseUrl) {
        var _this = this;
        if (baseUrl === void 0) { baseUrl = this.webApiUrl; }
        var url = "" + baseUrl + API_CONSTANTS.AUTHZ_ENDPOINT;
        if (this.isPublicTokenValid()) {
            return of(true);
        }
        return this.http.post(url, {})
            .pipe(map(function (response) {
            if (response && response.result && response.result.expires_in) {
                _this.setTokenCookie(response.result.expires_in);
            }
            return response;
        }));
    };
    /**
     * Sets a cookie that will expire 1 min before the
     * actual token expires.
     * @param expireTime expireTime in seconds.
     */
    AuthTokenService.prototype.setTokenCookie = function (expireTime) {
        var expireIn = Number(expireTime);
        // expire the token 1 min sooner
        // to make sure we renew the token at a safe moment.
        expireIn = expireIn > TIME.SECONDS ? expireIn - TIME.SECONDS : expireIn;
        var expireDate = new Date().getTime();
        expireDate += expireIn * TIME.MILLISECONDS;
        this.cookieService.set(COOKIES.publicTokenCookieName, expireDate.toString(), null, // this cookie will expire with the browser session
        '/');
    };
    /**
     * removes the token cookie
     */
    AuthTokenService.prototype.removeTokenCookie = function () {
        this.cookieService.delete(COOKIES.publicTokenCookieName, '/');
    };
    /**
     * Checks if the current token is expired
     * based on the existence of the token cookie.
     * @returns boolean
     */
    AuthTokenService.prototype.isPublicTokenValid = function () {
        var isValid = false;
        var expireTimeCookie = this.cookieService.get(COOKIES.publicTokenCookieName);
        if (expireTimeCookie) {
            isValid = Number(expireTimeCookie) - new Date().getTime() > 0;
            if (!isValid) {
                // remove the cookie if token is expired.
                this.removeTokenCookie();
            }
        }
        return isValid;
    };
    AuthTokenService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthTokenService_Factory() { return new AuthTokenService(i0.ɵɵinject(i1.ConfigService), i0.ɵɵinject(i2.CookieService), i0.ɵɵinject(i3.HttpClient)); }, token: AuthTokenService, providedIn: "root" });
    return AuthTokenService;
}());
export { AuthTokenService };
